import React from "react";
import styled from "styled-components";
import Content from "../../common/Content";
import Button from "../../ui/Button";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow-right.svg";
import DifficultySelector from "../../ui/DifficultySelector";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import GameArea from "../../ui/GameArea";
import PlayButton from "../../ui/PlayButton";
import ContentCenter from "../../ui/ContentCenter";
import BulletButton from "../../ui/BulletButton";
import Bullet from "../../ui/Bullet";

const FingerRunContainer = styled.div`
  position: absolute;
  top: 5%;
  left: 0%;
  width: 90%;
  height: 90%;
  background-image: url(/fingerrun/fingerrun.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 0;
`;

const words = [
  "SPORT",
  "LAUFEN",
  "WANDERN",
  "STEIGEN",
  "WERFEN",
  "SPRINGEN",
  "TANZEN",
  "KLETTERN",
  "BALANCIEREN",
  "SCHWIMMEN",
  "SPIELEN",
  "TRAINIEREN",
  "REITEN",
  "SCHAUKELN",
  "FECHTEN",
  "KRIECHEN",
  "FLIEGEN",
  "TURNEN",
  "HEBEN",
  "SCHWEBEN",
  "BOXEN",
  "RINGEN",
];

const WordContainer = styled.div`
  position: absolute;
  width: 300px;
  height: 45px;
  border-radius: 50px;
  bottom: 15%;
  left: 22%;
  border: 1px solid #ffb3b2;
  background-color: rgba(255, 247, 247, 0.95);
  z-index: 1;
  display: flex;
  padding-left: 20px;
  align-items: center;
`;

const WordSpan = styled.span`
  color: #e21110;
  font-size: 20px;
  font-weight: bold;
`;

const ArrowHolder = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #e21110;
  margin-right: 5px;
  :hover {
    background: #ccc;
  }`

const NewWordButton = styled.button`
  position: absolute;
  bottom: 5%;
  left: 50%;
  background-color: #fce8e8;
  font-weight: bolder;
  width: 150px;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 25px;
  z-index: 1;
  border-radius: 50px;
  border: 0px;
  cursor: pointer;
  :hover {
    background: #ffeeef;
    ${ArrowHolder} {
        background: #ccc;
    }
  }
`;



export default ({ onSetLevel, game }: any) => {
  const { t } = useTranslation("games");
  const [level, setLevel] = useState(1);
  const [started, setStarted] = useState(false);
  const [wordIndex, setWordIndex] = useState(0);

  useEffect(() => {
    setStarted(false);
  }, [level]);

  const startGame = () => {
    setStarted(true);
  };

  const showNextWord = () => {
    if (wordIndex === words.length - 1) setWordIndex(0);
    else setWordIndex(wordIndex + 1);
  };

  return (
    <>
      <GameArea game={game}>
        <BulletButton />
        <WordContainer>
          <WordSpan>{words[wordIndex]}</WordSpan>
        </WordContainer>
        {started ? (
          <NewWordButton onClick={showNextWord}>
            <ArrowHolder>
              <ArrowRight />
              </ArrowHolder>
            Neuer Begriff
          </NewWordButton>
        ) : null}
        <FingerRunContainer />
      </GameArea>
      <Content>
        <div>{started ? <></> : <PlayButton onClick={startGame} />}</div>
        <DifficultySelector
          switchDifficulty={(level) => {
            onSetLevel(level);
            setLevel(level);
            setWordIndex(0);
          }}
          levels={3}
          current={level}
        />
      </Content>
    </>
  );
};
